/* folder.icon.svg.js */

"use strict";
module.exports = {
    icon: `    
            <svg viewBox="0 0 24 24" preserveAspectRatio="none">
                <path class="foreground-gl" d="M21.6,19.2H2.4v-12h19.2 M21.6,4.8H12L9.6,2.4H2.4C1.1,2.4,0,3.5,0,4.8v14.4c0,1.3,1.1,2.4,2.4,2.4h19.2
                    c1.3,0,2.4-1.1,2.4-2.4v-12C24,5.9,22.9,4.8,21.6,4.8z"/>
            </svg>

         `,
};
